import type { User } from '../../../../core/interfaces/backend/usuarios/usuarios.administration.interface';
import type { Role } from '../../../../core/interfaces/backend/roles/roles.administration.interface';
import type { Assignment } from '../../../../core/interfaces/backend/reasignaciones_usuarios/reasignaciones_usuarios.administration.interface';
import { Component, inject, Input, Output, EventEmitter, OnChanges, computed, signal, effect } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AdministracionService } from '../../../../services/backend/administracion/administracion.service';
import { AdminDataTableComponent, GridRow } from '../../../../shared/admin-data-table/admin-data-table.component';
import { GovcoConfirmModalComponent } from '../../../../shared/govco/govco-confirm-modal/govco-confirm-modal.component';

@Component({selector:'sr-rol-formulario',standalone:true,imports:[FormsModule, GovcoConfirmModalComponent],templateUrl:'./rol-formulario.component.html',styleUrl:'./rol-formulario.component.css'})
export class RolFormularioComponent {
  readonly api=inject(AdministracionService);
  @Input() role:Role|null=null;
  @Output() readonly closed=new EventEmitter<void>();
  readOnly=false; name='';active=false;
  ngOnChanges():void{this.name=this.role?.name ?? '';this.active=this.role?.active ?? false;this.validation='';}
  get confirmationMessage():string{return 'Rol: '+this.name.trim()+'.';}
  askSave():void{
    const name=this.name.trim();this.validation='';
    if(!name || name.length>50){this.validation='Ingrese un nombre de rol de hasta 50 caracteres.';return;}
    if(this.api.data()?.roles.some(r=>r.id!==this.role?.id && r.name.toLocaleLowerCase('es')===name.toLocaleLowerCase('es'))){this.validation='Ya existe un rol con ese nombre.';return;}
    this.decision='save';
  }
  persist():void{this.api.save('/sd/roles/administration/save-role',{id:this.role?.id ?? null,name:this.name.trim(),active:this.active,instrumentId:this.api.instrumentId()},()=>this.closed.emit());}
  decision: 'save'|'cancel'|null=null;
  validation='';
  get confirmTitle(): string { return this.decision==='save'?'¿Está seguro que desea guardar los cambios realizados?':'¿Está seguro que desea cancelar los cambios realizados?'; }
  confirmDecision(): void { const action=this.decision; this.decision=null; if(action==='cancel') this.closed.emit(); else if(action==='save') this.persist(); }

}
